<template>
  <div class="spacing-playground">
    <v-form ref="form">
      <v-row>
        <v-col cols="12" md="12">
          <p class="text-h6">Datos del paquete</p>
        </v-col>
        <v-col v-if="!edit" class="mt-n5" cols="12" md="12">
          <v-text-field
            :rules="rules.required"
            label="Nombre"
            v-model="nm"
            outlined
            dense
            required
          ></v-text-field>
        </v-col>
        <v-col v-if="!edit" class="mt-n5" cols="12" md="3">
          <v-autocomplete
            v-model="dataToAdd.ct.id"
            dense
            :items="Categories"
            item-text="Nombre"
            item-value="id"
            label="Categoria"
          ></v-autocomplete>
        </v-col>
        <v-col v-if="!edit" class="mt-n5" cols="12" md="3">
          <v-text-field
            v-model="dataToAdd.pc.C"
            label="Precio"
            dense
            required
          ></v-text-field>
        </v-col>
        <v-col v-if="!edit" class="mt-n5" cols="12" md="3">
          <v-autocomplete
            v-model="dataToAdd.pc.M"
            :items="monedas"
            item-text="Nombre"
            item-value="id"
            dense
            label="Moneda"
          ></v-autocomplete>
        </v-col>
        <v-col v-if="!edit" class="mt-n5" cols="12" md="3">
          <v-btn v-if="!edit" color="primary" @click="addPrice()"
            >Agregar</v-btn
          >
        </v-col>
        <v-col class="mt-n5" cols="12" md="12">
          <v-list dense>
            <v-subheader>Precios</v-subheader>
            <v-list-item v-for="(precio, index) in ps" :key="index">
              <v-row>
                <v-col md="4" cols="12">
                  <h4 class="mt-4">{{ getCategoriaById(precio.ct.id) }}</h4>
                </v-col>
                <v-col md="4" cols="12">
                  <v-text-field
                    :disabled="edit"
                    v-model="precio.pc.C"
                    label="Precio"
                  ></v-text-field>
                </v-col>
                <v-col md="4" cols="12">
                  <v-btn
                    v-if="!edit"
                    class="mt-4"
                    color="red"
                    @click="deletePrice(index)"
                    dark
                    >Eliminar</v-btn
                  >
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
      <div class="text-right">
        <v-btn large @click="$emit('toggle', false)">Cancelar</v-btn>
        <v-btn
          v-if="!edit"
          @click="checkForm()"
          style="margin-left: 6px"
          color="success"
          large
          >Guardar</v-btn
        >
      </div>
    </v-form>
  </div>
</template>

<style scoped></style>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "PaquetesPrecioForm",
  components: {},
  props: ["edit", "dataEdit"],
  data() {
    return {
      Categories: [],
      dataToAdd: {
        ct: { id: "", nm: "" },
        pc: { C: 0, M: this.$Currencies.getCurrencyDefault() },
      },
      rules: {
        required: [(value) => !!value || "El campo es obligatorio"],
      },
      Id: "",
      nm: "",
      ps: [],
    };
  },
  computed: {
    ...mapGetters(["getPDVMonedasLista"]),
    ...mapGetters("Categorias", ["getCategoriesFiltered"]),
    monedas() {
      let monedas = [];
      this.getPDVMonedasLista.forEach((moneda) => {
        monedas.push(moneda);
      });
      return monedas;
    },
  },
  methods: {
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    addPrice() {
      let exist = this.$pgsHelper.getById(
        this.dataToAdd,
        "ct",
        this.dataToAdd.ct
      );
      if (!exist) {
        this.ps.push(this.$pgsHelper.cloneObj(this.dataToAdd));
      }
    },
    deletePrice(index) {
      this.ps.splice(index, 1);
    },
    getCategoriaById(id) {
      let exist = this.$pgsHelper.getById(this.Categories, "id", id);
      if (exist) {
        return exist.Nombre;
      } else {
        return "Categoria no valida";
      }
    },
    async getCategories() {
      await this.fetchCategories();
      const claims = this.$route.params?.user?.tokenResult?.claims;
      this.Categories = this.getCategoriesFiltered(claims);
    },
    checkForm() {
      if (this.$refs.form.validate()) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.ps.forEach((precio) => {
          precio.ct.nm = this.getCategoriaById(precio.ct.id);
          precio.pc.C = Number(precio.pc.C);
        });
        this.send(doAction);
      }
    },
    send(action) {
      const dataSave = this.$data;

      this.$emit("successData", dataSave, action);
    },
  },
  mounted() {
    this.getCategories();
    if (this.edit) {
      this.Id = this.dataEdit.id;
      this.nm = this.dataEdit.nm;
      this.ps = this.dataEdit.ps;
    }
  },
};
</script>
